// src/menu-items/admin.jsx

const admin = {
  id: 'group-admin-navigation',
  title: 'Admin Navigation',
  type: 'group',
  children: [
    {
      id: 'admin-dashboard',
      title: 'Admin Dashboard',
      type: 'item',
      icon: 'ph ph-house-line',
      url: '/admin'
    },

    {
      id: 'admin-identity-group',
      title: 'Identity & Access',
      type: 'collapse',
      icon: 'ph ph-user-circle-gear',
      children: [
        {
          id: 'admin-organizations',
          title: 'Organizations',
          type: 'item',
          icon: 'ph ph-buildings',
          url: '/admin/organizations',
          breadcrumbs: false
        },
        {
          id: 'admin-users',
          title: 'Users',
          type: 'item',
          icon: 'ph ph-users-three',
          url: '/admin/users',
          breadcrumbs: false
        },
        {
          id: 'admin-roles',
          title: 'Roles & access',
          type: 'item',
          icon: 'ph ph-identification-card',
          url: '/admin/roles',
          breadcrumbs: false
        },
        {
          id: 'admin-teams',
          title: 'Teams',
          type: 'item',
          icon: 'ph ph-users-four',
          url: '/admin/teams',
          breadcrumbs: false
        },
        {
          id: 'admin-sessions',
          title: 'Active sessions',
          type: 'item',
          icon: 'ph ph-devices',
          url: '/admin/system/sessions',
          breadcrumbs: false
        },
        {
          id: 'admin-identity-config',
          title: 'Identity config',
          type: 'item',
          icon: 'ph ph-lock-key',
          url: '/admin/identity-config',
          breadcrumbs: false
        }
      ]
    },

    {
      id: 'admin-platform-group',
      title: 'Platform & Config',
      type: 'collapse',
      icon: 'ph ph-sliders-horizontal',
      children: [
        {
          id: 'admin-tools',
          title: 'Tools',
          type: 'item',
          icon: 'ph ph-wrench',
          url: '/admin/tools',
          breadcrumbs: false
        },
        {
          id: 'admin-integrations',
          title: 'Integrations',
          type: 'item',
          icon: 'ph ph-plugs-connected',
          url: '/admin/integrations',
          breadcrumbs: false
        },
        {
          id: 'admin-connectors',
          title: 'Connectors',
          type: 'item',
          icon: 'ph ph-cloud-arrow-down',
          url: '/admin/connectors',
          breadcrumbs: false
        },
        {
          id: 'admin-threat-alerts',
          title: 'Threat alerts',
          type: 'item',
          icon: 'ph ph-warning-octagon',
          url: '/admin/threat-alerts',
          breadcrumbs: false
        },
        {
          id: 'admin-nuclei-templates',
          title: 'Nuclei templates',
          type: 'item',
          icon: 'ph ph-file-code',
          url: '/admin/nuclei-templates',
          breadcrumbs: false
        },
        {
          id: 'admin-announcements',
          title: 'Announcements',
          type: 'item',
          icon: 'ph ph-megaphone-simple',
          url: '/admin/announcements',
          breadcrumbs: false
        },
        {
          id: 'admin-notification-rules',
          title: 'Notification rules',
          type: 'item',
          icon: 'ph ph-bell-ringing',
          url: '/admin/notification-rules',
          breadcrumbs: false
        },
        {
          id: 'admin-maintenance',
          title: 'Maintenance',
          type: 'item',
          icon: 'ph ph-traffic-cone',
          url: '/admin/system/maintenance',
          breadcrumbs: false
        },
        {
          id: 'admin-settings',
          title: 'Settings',
          type: 'item',
          icon: 'ph ph-gear-six',
          url: '/admin/settings',
          breadcrumbs: false
        },
        {
          id: 'admin-api-keys',
          title: 'Third-party keys',
          type: 'item',
          icon: 'ph ph-key',
          url: '/settings/third-party-keys',
          breadcrumbs: false
        },
        {
          id: 'admin-webhooks',
          title: 'Webhooks',
          type: 'item',
          icon: 'ph ph-webhooks-logo',
          url: '/webhooks',
          breadcrumbs: false
        },
        {
          id: 'admin-exports',
          title: 'Data Exports',
          type: 'item',
          icon: 'ph ph-export',
          url: '/exports',
          breadcrumbs: false
        }
      ]
    },

    {
      id: 'admin-governance-group',
      title: 'Governance & Finance',
      type: 'collapse',
      icon: 'ph ph-shield-checkered',
      children: [
        {
          id: 'admin-policies',
          title: 'Scan policies',
          type: 'item',
          icon: 'ph ph-shield-check',
          url: '/admin/policies',
          breadcrumbs: false
        },
        {
          id: 'admin-sigma-rules',
          title: 'Sigma rules',
          type: 'item',
          icon: 'ph ph-file-magnifying-glass',
          url: '/admin/sigma-rules',
          breadcrumbs: false
        },
        {
          id: 'admin-policy-gates',
          title: 'Policy gates',
          type: 'item',
          icon: 'ph ph-shield-star',
          url: '/admin/policy-gates',
          breadcrumbs: false
        },
        {
          id: 'admin-sla-policy',
          title: 'SLA policy',
          type: 'item',
          icon: 'ph ph-timer',
          url: '/admin/sla-policy',
          breadcrumbs: false
        },
        {
          id: 'admin-case-automation',
          title: 'Case automation',
          type: 'item',
          icon: 'ph ph-robot',
          url: '/admin/case-automation',
          breadcrumbs: false
        },
        {
          id: 'admin-quotas',
          title: 'Quotas & limits',
          type: 'item',
          icon: 'ph ph-meter',
          url: '/admin/quotas',
          breadcrumbs: false
        },
        {
          id: 'admin-billing',
          title: 'Billing',
          type: 'item',
          icon: 'ph ph-credit-card',
          url: '/admin/billing',
          breadcrumbs: false
        },
        {
          id: 'admin-audit-logs',
          title: 'Audit logs',
          type: 'item',
          icon: 'ph ph-scroll',
          url: '/admin/audit-logs',
          breadcrumbs: false
        },
        {
          id: 'admin-case-tickets',
          title: 'Case tickets',
          type: 'item',
          icon: 'ph ph-ticket',
          url: '/admin/case-tickets',
          breadcrumbs: false
        },
        {
          id: 'admin-case-evidence',
          title: 'Case evidence',
          type: 'item',
          icon: 'ph ph-paperclip',
          url: '/admin/case-evidence',
          breadcrumbs: false
        },
        {
          id: 'admin-vex-statements',
          title: 'VEX statements',
          type: 'item',
          icon: 'ph ph-shield-check',
          url: '/admin/vex-statements',
          breadcrumbs: false
        }
      ]
    },

    {
      id: 'admin-ops-group',
      title: 'System Operations',
      type: 'collapse',
      icon: 'ph ph-activity',
      children: [
        {
          id: 'admin-system-health',
          title: 'System health',
          type: 'item',
          icon: 'ph ph-heartbeat',
          url: '/admin/system/health',
          breadcrumbs: false
        },
        {
          id: 'admin-job-monitor',
          title: 'Job queue',
          type: 'item',
          icon: 'ph ph-queue',
          url: '/admin/system/jobs',
          breadcrumbs: false
        },
        {
          id: 'admin-observability',
          title: 'Observability',
          type: 'item',
          icon: 'ph ph-chart-scatter',
          url: '/admin/observability',
          breadcrumbs: false
        },
        {
          id: 'admin-artifacts',
          title: 'Artifacts',
          type: 'item',
          icon: 'ph ph-archive-box',
          url: '/admin/artifacts',
          breadcrumbs: false
        },
        {
          id: 'admin-fingerprints',
          title: 'Dedup fingerprints',
          type: 'item',
          icon: 'ph ph-fingerprint',
          url: '/admin/fingerprints',
          breadcrumbs: false
        },
        {
          id: 'admin-oast-sessions',
          title: 'OAST sessions',
          type: 'item',
          icon: 'ph ph-radar',
          url: '/admin/oast-sessions',
          breadcrumbs: false
        }
      ]
    },

    {
      id: 'admin-scanning-group',
      title: 'Scanning Workspace',
      type: 'collapse',
      icon: 'ph ph-crosshair-simple',
      children: [
        {
          id: 'fuzzscan-targets-assets',
          title: 'Targets',
          type: 'item',
          icon: 'ph ph-crosshair',
          url: '/targets',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-scans',
          title: 'Web scans',
          type: 'item',
          icon: 'ph ph-globe-hemisphere-west',
          url: '/web-scans',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-network-scans',
          title: 'Network scans',
          type: 'item',
          icon: 'ph ph-hard-drives',
          url: '/network-scans',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-mobile-scans',
          title: 'Mobile scans',
          type: 'item',
          icon: 'ph ph-device-mobile',
          url: '/mobile-scans',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-vulns',
          title: 'Findings',
          type: 'item',
          icon: 'ph ph-bug-beetle',
          url: '/vulns',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-remediation',
          title: 'Remediation Center',
          type: 'item',
          icon: 'ph ph-wrench',
          url: '/remediation',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-supply-chain',
          title: 'Supply Chain',
          type: 'item',
          icon: 'ph ph-factory',
          url: '/supply-chain',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-cves',
          title: 'CVE Catalog',
          type: 'item',
          icon: 'ph ph-warning-octagon',
          url: '/cves',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-compliance',
          title: 'Compliance Matrix',
          type: 'item',
          icon: 'ph ph-shield-check',
          url: '/compliance',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-api-security',
          title: 'API Security',
          type: 'item',
          icon: 'ph ph-plugs-connected',
          url: '/api-security',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-fuzzing',
          title: 'Fuzzing',
          type: 'item',
          icon: 'ph ph-flask',
          url: '/fuzzing',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-secrets',
          title: 'Secrets Detection',
          type: 'item',
          icon: 'ph ph-key',
          url: '/secrets',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-sbom',
          title: 'SBOM',
          type: 'item',
          icon: 'ph ph-package',
          url: '/sbom',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-attack-surface',
          title: 'Attack Surface',
          type: 'item',
          icon: 'ph ph-radar',
          url: '/attack-surface',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-engagements',
          title: 'Engagements',
          type: 'item',
          icon: 'ph ph-clipboard-text',
          url: '/engagements',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-exploits',
          title: 'Exploit Database',
          type: 'item',
          icon: 'ph ph-terminal',
          url: '/exploits',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-scan-diff',
          title: 'Scan Comparison',
          type: 'item',
          icon: 'ph ph-arrows-left-right',
          url: '/scan-diff',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-scan-templates',
          title: 'Scan Templates',
          type: 'item',
          icon: 'ph ph-code',
          url: '/scan-templates',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-cloud-posture',
          title: 'Cloud Posture',
          type: 'item',
          icon: 'ph ph-cloud',
          url: '/cloud-posture',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-shared-links',
          title: 'Shared Links',
          type: 'item',
          icon: 'ph ph-share-network',
          url: '/shared-links',
          breadcrumbs: false
        }
      ]
    }
  ]
};

// Admins also use the normal scanning menu. That menu is shown first as its own "Workspace" group (see navigation.jsx),
// so this group holds only what administrators manage. The old partial "Scanning Workspace" group is dropped.
const adminOnly = admin.children.filter((item) => item.id !== 'admin-scanning-group');

export default { ...admin, title: 'Administration', children: adminOnly };
